/**
 * Contracts enforced by OfficeEventSchema (OES)
 */
export class App {
  constructor(name, version) {
    if (!name) {
      throw new Error("name must not be null");
    }
    if (!version) {
      throw new Error("version must not be null");
    }
    this.name = name;
    this.version = version;
  }
  getName() {
    return this.name;
  }
  getPlatform() {
    return App.PLATFORM;
  }
  getVersion() {
    return this.version;
  }
}
App.PLATFORM = "Web";
export class Session {
  constructor(id) {
    if (!id) {
      throw new Error("id must not be null");
    }
    this.id = id;
  }
  getId() {
    return this.id;
  }
}
export class Host {
  constructor(id, locale, sessionId, version) {
    this.id = id;
    this.locale = locale;
    this.sessionId = sessionId;
    this.version = version;
  }
  getId() {
    return this.id;
  }
  getLocale() {
    return this.locale;
  }
  getSessionId() {
    return this.sessionId;
  }
  getVersion() {
    return this.version;
  }
}
export class Event {
  constructor(name, sessionId, sequence, sampleRate) {
    if (!name) {
      throw new Error("name must not be null");
    }
    if (!sessionId) {
      throw new Error("sessionId must not be null");
    }
    if (!sequence && sequence !== 0 || sequence < 0) {
      throw new Error("sequence must not be negative");
    }
    this.name = name;
    this.id = sessionId + Event.ID_DELIMITER + sequence;
    this.sequence = sequence;
    this.sampleRate = sampleRate;
  }
  getName() {
    return this.name;
  }
  getId() {
    return this.id;
  }
  getSource() {
    return Event.SOURCE;
  }
  getSchemaVersion() {
    return Event.SCHEMA_VERSION;
  }
  getSequence() {
    return this.sequence;
  }
  getSampleRate() {
    return this.sampleRate;
  }
}
// Id is set to sessionId<DELIMITER>sequence
Event.ID_DELIMITER = ".";
Event.SOURCE = "MsoThin";
Event.SCHEMA_VERSION = 1;
export class Release {
  constructor(audienceGroup) {
    this.audienceGroup = audienceGroup;
  }
  getAudienceGroup() {
    return this.audienceGroup;
  }
}
export class Browser {
  constructor(name, version) {
    this.name = name;
    this.version = version;
  }
  getName() {
    return this.name;
  }
  getVersion() {
    return this.version;
  }
}
export class Device {
  constructor(id) {
    this.id = id;
  }
  getId() {
    return this.id;
  }
}
export class User {
  constructor(primaryIdentityHash, tenantId) {
    this.tenantId = tenantId;
    this.primaryIdentityHash = primaryIdentityHash ? primaryIdentityHash.trim() : primaryIdentityHash;
    this.primaryIdentitySpace = this.generatePrimaryIdentitySpace();
  }
  getTenantId() {
    return this.tenantId;
  }
  getPrimaryIdentityHash() {
    return this.primaryIdentityHash;
  }
  getPrimaryIdentitySpace() {
    return this.primaryIdentitySpace;
  }
  generatePrimaryIdentitySpace() {
    if (this.primaryIdentityHash) {
      if (this.primaryIdentityHash.startsWith("a:")) {
        return "UserObjectId";
      }
      if (this.primaryIdentityHash.startsWith("p:")) {
        return "MsaPuid";
      }
      if (this.primaryIdentityHash.startsWith("ap:")) {
        return "OrgIdPuid";
      }
    }
    return undefined;
  }
}